import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Oil } from '../../types/Oil.type';
import { RootState } from '../store';

interface OilsState {
  oils: Oil[];
}

const initialState: OilsState = {
  oils: [],
};

const oilsSlice = createSlice({
  name: 'oils',
  initialState,
  reducers: {
    storeOils: (state, { payload }: PayloadAction<Oil[]>) => {
      state.oils = payload;
    },
    clearOils: (state) => {
      state.oils = [];
    },
  },
});

export const { storeOils, clearOils } = oilsSlice.actions;

export const getOils = (state: RootState) => state.oils.oils;

export default oilsSlice.reducer;
